import * as Sentry from '@sentry/react';

export default function SentryErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      fallback={(errorFallbackProps) => (
        <main className="pt-16 p-4 container mx-auto">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Something went wrong</h1>
          <p className="text-gray-700 mb-4">
            An unexpected error occurred. Our team has been notified.
          </p>
          <button
            onClick={() => errorFallbackProps.resetError()}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Try again
          </button>
          {import.meta.env.DEV && errorFallbackProps.error instanceof Error && (
            <details className="mt-4">
              <summary className="cursor-pointer text-sm text-gray-600">
                Error details (dev only)
              </summary>
              <pre className="mt-2 p-4 bg-gray-100 rounded text-xs overflow-auto">
                {errorFallbackProps.error.message}
                {errorFallbackProps.error.stack}
              </pre>
            </details>
          )}
        </main>
      )}
      beforeCapture={(scope) => {
        // Add custom context before sending to Sentry
        scope.setTag('errorBoundary', 'app-level');
        scope.setContext('errorInfo', {
          location: 'app-level-boundary',
        });
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
